import api from './api'

export const usersAPI = {
  // Get user statistics for dashboard
  getStats: () => api.get('/users/stats/overview'),
  
  // Get all users
  getAll: (params = {}) => api.get('/users', { params }),
  
  // Get user by ID
  getById: (id) => api.get(`/users/${id}`),
  
  // Create new user
  create: (userData) => api.post('/users', userData),
  
  // Update user
  update: (id, userData) => api.put(`/users/${id}`, userData),
  
  // Delete user
  delete: (id) => api.delete(`/users/${id}`),
  
  // Update user status
  updateStatus: (id, status) => api.patch(`/users/${id}/status`, { status }),
  
  // Get user permissions
  getPermissions: (id) => api.get(`/users/${id}/permissions`),
  
  // Get users by organization
  getByOrganization: (organizationId, params = {}) => api.get(`/users/organization/${organizationId}`, { params }),
  
  // Get archived users by organization
  getArchivedByOrganization: (organizationId, params = {}) => api.get(`/users/organization/${organizationId}/archived`, { params }),
  
  // Get recent activities
  getRecentActivities: (limit = 10) => api.get('/users/activities/recent', { params: { limit } }),
  
  // Get users from archived organizations (all archived orgs - control center)
  getArchivedOrganizationUsers: (params = {}) => api.get('/users/archived-organizations', { params })
}

